module.exports = __webpack_public_path__ + "static/media/ico-chart.bed88fd3.svg";